export enum RequestQueryKeysE {
  FetchTickets = 'fetchTickets',
  FetchTicket = 'fetchTicket',
  FetchTicketAttachments = 'fetchTicketAttachments',
  FetchTicketMessages = 'fetchTicketMessages',
  CreateTicket = 'createTicket',
  CreateMultipleTickets = 'createMultipleTickets',
  CreateTicketMessage = 'createTicketMessage',
  CreateTicketAttachment = 'createTicketAttachment',
  CreateTicketMultiAttachment = 'createTicketMultiAttachment',
  CreateTicketMultiPartAttachmentInitiate = 'createTicketMultiPartAttachmentInitiate',
  CreateTicketMultiPartAttachmentUpload = 'createTicketMultiPartAttachmentUpload',
  CreateTicketMultiPartAttachmentComplete = 'createTicketMultiPartAttachmentComplete',
  ReopenTicket = 'reopenTicket',
  ApproveTicket = 'approveTicket',
  GetApprovalTicket = 'getApprovalTicket',
  CloseTicket = 'closeTicket',
  FetchTicketsCountByRoofTop = 'fetchTicketsCountByRoofTop',
  FetchTicketsTotalsByRoofTop = 'fetchTicketsTotalsByRoofTop',
  FetchUserAuthTokens = 'fetchUserAuthTokens',
  FetchTicketRequestCategories = 'fetchTicketRequestCategories',
  FetchTicketRequestSubcategories = 'fetchTicketRequestSubcategories',
  FetchClaimStatuses = 'fetchClaimStatuses',
  FetchPriorities = 'fetchPriorities',
  ChangeTicketClaimStatus = 'changeTicketClaimStatus',
  ChangeTicketSubcategory = 'changeTicketSubCategoryId',
  ChangeTicketReadStatus = 'changeTicketReadStatus',
  ChangeTicketUnreadStatus = 'changeTicketUnreadStatus',
  ChangeTicketPriority = 'changeTicketPriority',
  FetchAvailableFileTypes = 'fetchAvailableFileTypes',
  FetchUser = 'fetchUser',
  FetchAgentsList = 'fetchAgentsList',
  UpdateUser = 'updateUser',
  FetchAttachment = 'fetchAttachment',
  FetchViewAttachment = 'fetchViewAttachment',
  GetAttachmentUrl = 'getAttachmentUrl',
  GetAttachmentFromSignedUrl = 'getAttachmentFromSignedUrl',
  DeleteAttachment = 'deleteAttachment',
  ApproveAttachments = 'approveAttachments',
  FetchTicketsReportLastMonth = 'fetchTicketsReportLastMonth',
  FetchClaimReportCards = 'fetchClaimReportCards',
  FetchGroupedReleaseNotes = 'fetchGroupedReleaseNotes',
  FetchNotificationsHistory = 'fetchNotificationsHistory',
  UpdateNotificationHistoryStatus = 'updateNotificationHistoryStatus',
  UpdateNotificationsHistoryStatus = 'updateNotificationsHistoryStatus',
  DeleteTicket = 'deleteTicket',
  ReassignTicket = 'reassignTicket',
  ShareTicket = 'shareTicket',
  FetchBannerMessages = 'fetchBannerMessages',
  FetchRepairOrder = 'fetchRepairOrder',
  ChirpTicketDetailsChange = 'changeTicketDetails',
  FetchUserColumnPreferences = 'fetchUserColumnPreferences',
  UpdateUserColumnPreferences = 'updateUserColumnPreferences',
  ExportTickets = 'exportTickets',
  ExportScheduleTickets = 'exportScheduleTickets',
  FetchLatestReleaseNote = 'fetchLatestReleaseNote',
  ImportSchedule = 'importSchedule',
  FetchMappedRooftopsList = 'fetchMappedRooftopsList',
  FetchDmsScheduleAccounts = 'fetchDmsScheduleAccounts',
  FetchTechNumberList = 'fetchTechNumberList',
  FetchAdvisorNumberList = 'fetchAdvisorNumberList',
  GetAttachmentTypes = 'getAttachmentTypes',
  FetchDmsScheduleAutomationStatus = 'fetchDmsScheduleAutomationStatus',
  CreateDmsScheduleIntegrationRequest = 'createDmsScheduleIntegrationRequest',
  FetchDashboardIds = 'fetchDashboardIds',
  FetchEmbedUrl = 'fetchEmbedUrl',
  AddWipRecordFromSchedule = 'addWipRecordFromSchedule',
}

export enum RequestStaleTimeE {
  GroupedReleaseNotes = 300000,
  TicketsReportLastMonth = 300000,
  ClaimReportCards = 300000,
  TicketRequestCategories = 60000,
  ClaimStatuses = 60000,
  Priorities = 60000,
  Tickets = 60000,
  Ticket = 60000,
  TicketsCountByRoofTop = 60000,
  TicketAttachments = 60000,
  TicketMessages = 60000,
  UserProfile = 300000,
  CodeTranslations = 300000,
}
